module.exports = __webpack_public_path__ + "img/12.3459ac53.jpg";